import React from 'react';
import { AlertTriangle } from 'lucide-react';

const gbp = (n) => `£${Number(n || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Staff-only cost / profit / margin strip for an order card (all figures ex VAT). */
export function OrderProfitBadge({ profit, orderId }) {
  if (!profit || !profit.lines) return null;
  if (!profit.costed) {
    return (
      <div className="mt-1.5 rounded-md border border-dashed border-gray-300 px-2 py-1 text-[10px] text-gray-500" data-testid={`order-profit-${orderId}`} title={`No cost set for: ${profit.missing.join(', ')}. Link products to Xero or set a cost on the Pricing page.`}>
        Profit unknown — no product costs yet
      </div>
    );
  }
  const tone = profit.margin_pct == null ? 'text-gray-500' : profit.margin_pct < 20 ? 'text-rose-700' : profit.margin_pct < 35 ? 'text-amber-700' : 'text-emerald-700';
  const partial = !profit.complete;
  return (
    <div className={`mt-1.5 rounded-md border px-2 py-1 text-[11px] ${partial ? 'border-amber-200 bg-amber-50/60' : 'border-gray-200 bg-gray-50'}`} data-testid={`order-profit-${orderId}`}
      title={partial ? `No cost for: ${profit.missing.join(', ')}${profit.missing.length < profit.lines - profit.costed ? '…' : ''}. Set costs / links on the Pricing page.` : `Revenue ${gbp(profit.revenue)} · cost ${gbp(profit.cost)} · all ex VAT`}>
      <div className="flex items-center justify-between gap-2">
        <span className="text-gray-600">Cost <span className="font-semibold text-gray-900">{gbp(profit.cost)}</span>{partial && <span className="text-amber-700">+</span>}</span>
        <span className={`font-bold ${tone}`} data-testid={`order-profit-margin-${orderId}`}>
          {partial && <AlertTriangle className="w-3 h-3 inline mr-0.5 -mt-0.5 text-amber-600" />}
          {gbp(profit.profit)}{profit.margin_pct != null && <span className="font-semibold opacity-80"> · {profit.margin_pct}%</span>}
        </span>
      </div>
      {partial && <div className="text-[10px] text-amber-800 mt-0.5">{profit.lines - profit.costed} of {profit.lines} line{profit.lines === 1 ? '' : 's'} without a cost</div>}
    </div>
  );
}
